 <template>
  <div class="col-12">
    <b-modal v-model="confirmRemoveModal"
      title="Remover Categoria de Processo"
      class="modal-primary"
      @ok="removeFile">
      Deseja remover #{{ instance.id }} {{ instance.name }} do site ? Ao confirmar essa ação, o item não poderá ser recuperado.
      <br/>
    </b-modal>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <template v-if="instance.type === 'images'" >
            <div class="col-1" v-if="!instance.thumbnail_url">
              <i class="fa fa-file-o"></i>
            </div>
            <div class="col-sm-2 col-xl-1" v-if="instance.thumbnail_url">
              <div class="image-container d-flex justify-content-center align-items-center">
                <img class="card-img-top" :src="instance.thumbnail_url ? instance.thumbnail_url : ''" blank :alt="instance.name" />
              </div>
            </div>

            <h6 class="col-sm-8 col-xl-10 mb-0">
              {{ instance.name }}
            </h6>
          </template>

          <template v-if="instance.type === 'video'">
            <div class="col-sm-2 col-xl-1">
              <div class="image-container d-flex justify-content-center align-items-center">
                <img class="card-img-top" :src="instance.thumbnail_url" blank :alt="instance.name" />
              </div>
            </div>

            <h6 class="col-sm-8 col-xl-10  mb-0">
              {{ instance.name }}
            </h6>
          </template>

          <template v-if="instance.type === 'files'">
            <div class="col-1">
              <i class="fa fa-file-o"></i>
            </div>

            <!-- @todo create the different types of card for the types of ProcessItems (video/files/image) -->
            <h6 class="col-sm-9 col-xl-10">
              {{ instance.name }}
            </h6>
          </template>

          <div class="col-sm-2 col-xl-1">
            <div class="row">
              <div class="col p-0">
                <router-link :to="{
                  name: 'manageables.edit',
                  params: { entity: 'bl-process-items', id: instance.id }
                }">

                  <i class="fa fa-edit" v-b-tooltip.hover title="Editar"></i>
                </router-link>
              </div>
              <div class="col p-0 cursor-pointer">
                <i @click.stop.prevent="handleRemove" class="fa fa-trash-o" v-b-tooltip.hover title="Remover"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'

export default {
  props: {
    instance: {
      type: Object,
      default () {
        return {
          media: []
        }
      }
    },
    http: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      confirmRemoveModal: false
    }
  },
  computed: {
    mediaInstance () {
      if (!isEmpty(this.instance.media)) {
        return this.instance.media[0]
      }

      return {}
    }
  },
  methods: {
    removeFile () {
      const self = this
      this.$Progress.start()
      self.confirmRemoveModal = false
      self.http.destroy(self.instance.id)
        .then((res) => {
          // self.$emit('item-removed', self.instance)
          location.reload()
          self.$toasted.success('Item removido com sucesso.')
        })
    },
    handleRemove () {
      if (this.instance.id) {
        this.confirmRemoveModal = true
        return null
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  .fa
    position: relative
    z-index: 9999
  i.success
    color: #4dbd74
</style>



// WEBPACK FOOTER //
// src/components/forms/Bl/ProcessItemCard.vue